import posthog from "posthog-js";

let initialized = false;

export function initAnalytics() {
  // Only track in the mobile app (Capacitor), not on the web/admin
  const isCapacitor = window.location.protocol === "capacitor:" || window.location.hostname === "localhost";
  if (!isCapacitor) return;

  const key = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
  const host = (import.meta.env.VITE_POSTHOG_HOST as string | undefined) || "https://us.i.posthog.com";
  if (!key || initialized) return;
  posthog.init(key, {
    api_host: host,
    autocapture: true,
    capture_pageview: true,
    persistence: "localStorage",
  });
  initialized = true;
}

export function track(event: string, properties?: Record<string, unknown>) {
  try { if (initialized) posthog.capture(event, properties); } catch {}
}

export function identify(userId: string, properties?: Record<string, unknown>) {
  try { if (initialized) posthog.identify(userId, properties); } catch {}
}
